module.exports = __webpack_public_path__ + "img/Immagini_3D_Icon.6aba9328.png";